import { useContext } from 'react';
import { LocaleContext } from '../providers/LocaleProvider/LocaleProvider';

const useLocale = () => {
  return useContext(LocaleContext);
};

export default useLocale;
